import { useLenis } from "@/hooks/useLenis";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Company } from "@/components/site/Company";
import { Flagship } from "@/components/site/Flagship";
import { PlatformFlow } from "@/components/site/PlatformFlow";
import { Integrations } from "@/components/site/Integrations";
import { Ecosystem } from "@/components/site/Ecosystem";
import { WhyCogentis } from "@/components/site/WhyCogentis";
import { Vision } from "@/components/site/Vision";
import { CTA } from "@/components/site/CTA";
import { Footer } from "@/components/site/Footer";
import { DemoTransition } from "@/components/site/DemoTransition";
import { DemoProvider } from "@/context/DemoContext";

export default function Landing() {
  useLenis(true);

  return (
    <DemoProvider>
      <div className="relative min-h-screen bg-[#040405]" data-testid="landing-page">
        <Navbar />
        <main>
          <Hero />
          <Marquee />
          <Company />
          <Flagship />
          <PlatformFlow />
          <Integrations />
          <Ecosystem />
          <WhyCogentis />
          <Vision />
          <CTA />
        </main>
        <Footer />
        <DemoTransition />
      </div>
    </DemoProvider>
  );
}
